import { Badge } from '@mantine/core';

export const ProBadge = () => {
  return (
    <Badge size="xs" style={{ textTransform: 'initial' }} color="orange">
      PRO
    </Badge>
  );
};
